import { app } from '../../../app';
import { HardToken } from '../../../models/hard-token';
import { accountFromDto } from './account.dto';

class UsersResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    /**
     * @param {string} companyId
     * @param {('roles' | 'all' | 'sms' | 'regular' | 'hardtoken')} type
     */
    getAllRegularCompanyUsers(companyId, type) {
        const url = `app/rest/v2/company/${companyId}/users`;
        const params = {type};
        return this.$http.get(url, {params}).then(({data}) => data);
    }
    
    getCompanyUserForSaaspassUser(companyId, searchText) {
        const url = `app/rest/v2/company/${companyId}/users`;
        const params = {uid: searchText};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    getCompanyUser(companyId, companyUserId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}`;
        return this.$http.get(url).then(({data}) => data);
    }

    deleteCompanyUser(companyId, companyUserId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}`;
        return this.$http.delete(url).then(({data}) => data);
    }

    getCompanyUserHardToken(companyId, companyUserId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}/hardtoken`;
        return this.$http.get(url).then(({data}) => new HardToken(data));
    }

    unblockCompanyUser(companyId, companyUserId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}`;
        const params = {action: 'unblock'};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    pauseCompanyUser(companyId, companyUserId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}`;
        const params = {action: 'pause'};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    unpauseCompanyUser(companyId, companyUserId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}`;
        const params = {action: 'unpause'};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    activateSmsUsageForCompanyUser(companyId, companyUserId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}`;
        const params = {action: 'activatesms'};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    deactivateSmsUsageForCompanyUser(companyId, companyUserId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}`;
        const params = {action: 'deactivatesms'};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    editDisplayNameOfEmployee(companyId, companyUserId, displayname) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}`;
        const params = {action: 'edit', displayname};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    getAllAccountsForCompanyUser(companyId, companyUserId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}/accounts`;
        return this.$http.get(url).then(({data}) => data);
    }

    getAllDevicesForCompanyUser(companyId, companyUserId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}/getdevices`;
        return this.$http.get(url).then(({data}) => data);
    }

    getAllAccountsDisplayNames(companyId, companyUserId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}/accounts`;
        const params = {type: 'displayname'};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    addNewAccountForUser(companyId, companyUser, username) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUser.id}/accounts`;
        const params = {username};
        return this.$http.post(url, null, {params}).then(({data}) => data)
            .then(account => accountFromDto(account, companyUser))
    }

    addHardtokenUserWithAccount(companyId, companyUser, username) {
        const url = `app/rest/v2/company/${companyId}/users/hardtoken`;
        const params = {action: 'activate', username};
        return this.$http.post(url, companyUser, {params}).then(({data}) => data);
    }

    changeNotificationEmail(companyId, companyUserId, accountId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}/accounts/${accountId}`;
        const params = {action: 'changemail'};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    getUserSharedServiceAccounts(companyId, companyUserId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}/shared`;
        return this.$http.get(url).then(({data}) => data);
    }
    deleteUserSharedServiceAccounts(companyId, companyUserId,selectedAccountsIds) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}/shared`;
        return this.$http.post(url,selectedAccountsIds).then(({data}) => data);
    }
    getUserSharedNotes(companyId, companyUserId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}/notes`;
        return this.$http.get(url).then(({data}) => data);
    }
    deleteUserSharedNotes(companyId, companyUserId,selectedNotesIds) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}/notes`;
        return this.$http.post(url,selectedNotesIds).then(({data}) => data);
    }
        
    getUsersBackupOtps(companyId,companyUserId) {
		var req = {
			method: 'GET',
			url: `app/rest/v2/company/${companyId}/users/${companyUserId}/backupcodes`
		}
	 	//const url = `app/rest/v2/company/${companyId}/users/${companyUserId}/backupcodes`;
		 return this.$http(req).then(({data}) => data);
	}

}

app.service('UsersResource', UsersResource);



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/users-resource.service.js